
export default {
  methods: {
    open(url) {
      window.open(url, '_blank')
    }
  }
}
